import {DomainObject} from 'shared/store';
import { action, computed, observable, makeObservable } from 'mobx';
import _ from 'lodash';

class QAAnswer extends DomainObject {
  question;
  correct;

  constructor(other) {
    super();

    makeObservable(this, {
      question: observable,
      correct: observable,
      updateValue: action,
      formattedValue: computed
    });

    this.merge(other);
  }

  updateValue(value) {
    this.value = value;
  }

  get formattedValue() {
    if (this.question.questionType === 'multi_select') {
      return _.join(this.value || [], ', ');
    } else {
      return this.value;
    }
  }
}

export default QAAnswer;
